import React from "react";
import { Container, Row, Col, Carousel, Card } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";


function CelebratingCampaign() {
  return (
    <>
      <Container>
      <div class="row">
      <div class="col-12">
        <div class="contentbox clelebrateslider">
        <h1 className="cus_text60">CELEBRATING THE CAMPAIGN</h1>
        <p className="cus_text30">
          Many hearts and minds along with <strong style={{ fontWeight: "bold", fontFamily: "Roboto black" }}>Ayappa K.M, Bharat Sikka and Sneha Khanwalkar</strong> came together to bring the Steel of India campaign to life, transforming it into a vibrant tribute to India. Its bold vision and even bolder execution were widely celebrated around the globe and went on to earn critical acclaim.
          
        </p>

        <Carousel className="pt-4">
          {/* First Carousel Slide */}
          <Carousel.Item>
            <Row className="pb-4 d-flex justify-content-center">
              <Col xs={10} md={6}>
                <Card className="text-center">
                  <Card.Img
                    variant="top"
                    src="https://d2lptvt2jijg6f.cloudfront.net/jspsteelpower20/custom/1737826292product1.png"
                    alt="Product 1"
                    style={{ height: "auto", objectFit: "cover" }}
                  />
                  <Card.Body className=" p-3">
                    <Card.Title>
                      <strong>Cannes Lion - Silver</strong> <br />
                      <span
                        style={{
                          FontSize: "10px",
                          color: "#636366",
                          fontFamily: "Roboto light",
                        }}
                      >
                        Editing
                      </span>
                    </Card.Title>
                    {/* <Card.Text>Editing</Card.Text> */}
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Carousel.Item>
          {/* Second Carousel Slide */}
          <Carousel.Item>
            <Row className="pb-4 d-flex justify-content-center">
              <Col xs={10} md={6}>
                <Card className="text-center">
                  <Card.Img
                    variant="top"
                    src="https://d2lptvt2jijg6f.cloudfront.net/jspsteelpower20/custom/1737826292product2.png"
                    alt="Product 2"
                    style={{ height: "auto", objectFit: "cover" }}
                  />
                  <Card.Body className="p-3">
                    <Card.Title>
                      <strong>Cannes Lion - Bronze</strong> <br />
                      <span
                        style={{
                          FontSize: "10px",
                          color: "#636366",
                          fontFamily: "Roboto light",
                        }}
                      >
                        Editing
                      </span>
                    </Card.Title>
                    {/* <Card.Text>Direction</Card.Text> */}
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Carousel.Item>
          {/* Third Carousel Slide */}
          <Carousel.Item>
            <Row className="pb-4 d-flex justify-content-center">
              <Col xs={10} md={6}>
                <Card className="text-center">
                  <Card.Img
                    variant="top"
                    src="https://d2lptvt2jijg6f.cloudfront.net/jspsteelpower20/custom/1737826292product5.png"
                    alt="Product 5"
                    style={{ height: "auto", objectFit: "cover" }}
                  />
                  <Card.Body className=" p-3">
                    <Card.Title>
                      <strong>Cannes Lion - Silver</strong> <br />
                      <span
                        style={{
                          FontSize: "10px",
                          color: "#636366",
                          fontFamily: "Roboto light",
                        }}
                      >
                        Editing
                      </span>
                    </Card.Title>
                    {/* <Card.Text>Editing</Card.Text> */}
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Carousel.Item>
          {/* Fourth Carousel Slide */}
          <Carousel.Item>
            <Row className="pb-4 d-flex justify-content-center">
              <Col xs={10} md={6}>
                <Card className="text-center">
                  <Card.Img
                    variant="top"
                    src="https://d2lptvt2jijg6f.cloudfront.net/jspsteelpower20/custom/1740202661_vimeo.png"
                    alt="Product 5"
                    style={{ height: "auto", objectFit: "cover" }}
                  />
                  <Card.Body className=" p-3">
                    <Card.Title>
                      <strong>Vimeo</strong> <br />
                      <span
                        style={{
                          FontSize: "10px",
                          color: "#636366",
                          fontFamily: "Roboto light",
                        }}
                      >
                        Best Branded Films 
                      </span>
                    </Card.Title>
                    {/* <Card.Text>Editing</Card.Text> */}
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Carousel.Item>
           {/* Fourth Carousel Slide */}
        </Carousel>
        </div>
        </div>
        </div>
      </Container>
    </>
  );
}

export default CelebratingCampaign;
